function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, props), React.createElement("g", {
  clipPath: "url(#clip0_2158_2386)"
}, React.createElement("path", {
  d: "M8 16A8 8 0 108 0a8 8 0 000 16z",
  fill: "#2991B4"
}), React.createElement("path", {
  d: "M11.555 5.778l-4.888 4.89-2.223-2.223",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip0_2158_2386"
}, React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
})))));